import { useState } from "react";
import { ReportCatalogSidebar, RoleManagementReportExport, UserManagementReportExport, ParticipantManagementReportExport, RuleEngineReportExport, MccBlockReportExport, CountryCodeBlockReportExport, AuthenticationManagementReportExport, ReportExportJobsModal } from "../../components";
import { ReportCatalogContainer, ReportCatalogMain, ReportCatalogMainEmpty, ReportCatalogMainHead, ReportCatalogWrapper } from "./report-catalog.style";
import { ReportCatalogModules, ReportCatalogModulesConstant } from "./report-catalog.constants";
import { CrossBoldSvg } from "../../assets/svgs";
import { useSelector } from "react-redux";

const ReportCatalog = () => {
    const { user } = useSelector((state) => state.loginUserReducer);

    const initialStates = {
        selectedModule: null,
        isJobsModalOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const handleSidebarClick = (e) => {
        if (e?.value) {
            setStates(() => ({ ...initialStates, selectedModule: e || null }));
        }
    };

    const handleToggleJobsModal = () => {
        setStates((old) => ({ ...old, isJobsModalOpen: !old.isJobsModalOpen }));
    };

    return (
        <>
            <style>
                {`
                  .update-layout-body {
                    padding: 0;
                  }
                `}
            </style>
            <ReportCatalogWrapper className="box-shadow">
                <ReportCatalogContainer>
                    {/* left */}
                    <ReportCatalogSidebar data={ReportCatalogModules(user)} selected={states?.selectedModule} handleSidebarClick={handleSidebarClick} handleToggleJobsModal={handleToggleJobsModal} />

                    {/* right */}
                    {
                        states?.selectedModule ? (
                            <ReportCatalogMain $selectModule={states?.selectedModule ? true : false}>
                                {
                                    states?.selectedModule?.label &&
                                    <ReportCatalogMainHead>
                                        <h2>{states?.selectedModule?.label}</h2>

                                        <div onClick={() => setStates((old) => ({ ...old, selectedModule: null }))}>
                                            <CrossBoldSvg />
                                        </div>
                                    </ReportCatalogMainHead>
                                }
                                <div style={{ flex: 1, overflow: 'hidden' }}>
                                    {
                                        states?.selectedModule?.value === ReportCatalogModulesConstant?.role &&
                                        <RoleManagementReportExport selectedModule={states?.selectedModule} />
                                    }
                                    {
                                        states?.selectedModule?.value === ReportCatalogModulesConstant?.user &&
                                        <UserManagementReportExport selectedModule={states?.selectedModule} />
                                    }
                                    {
                                        states?.selectedModule?.value === ReportCatalogModulesConstant?.participant &&
                                        <ParticipantManagementReportExport selectedModule={states?.selectedModule} />
                                    }
                                    {
                                        states?.selectedModule?.value === ReportCatalogModulesConstant?.ruleEngine &&
                                        <RuleEngineReportExport selectedModule={states?.selectedModule} />
                                    }
                                    {
                                        states?.selectedModule?.value === ReportCatalogModulesConstant?.mcc &&
                                        <MccBlockReportExport selectedModule={states?.selectedModule} />
                                    }
                                    {
                                        states?.selectedModule?.value === ReportCatalogModulesConstant?.countryCodeBlock &&
                                        <CountryCodeBlockReportExport selectedModule={states?.selectedModule} />
                                    }
                                    {
                                        states?.selectedModule?.value === ReportCatalogModulesConstant?.authentication &&
                                        <AuthenticationManagementReportExport selectedModule={states?.selectedModule} />
                                    }
                                </div>
                            </ReportCatalogMain>
                        ) : (
                            <ReportCatalogMain>
                                <ReportCatalogMainEmpty>
                                    <h4>No report selected</h4>
                                    <p>Select a report from the catalog to get started</p>
                                </ReportCatalogMainEmpty>
                            </ReportCatalogMain>
                        )
                    }
                </ReportCatalogContainer>
            </ReportCatalogWrapper>

            {/* JOBS MODAL */}
            {
                states.isJobsModalOpen &&
                <ReportExportJobsModal close={handleToggleJobsModal} slide />
            }
        </>
    );
};

export default ReportCatalog;